export const getStoredFilePath = (
  src: unknown,
  supabaseUrl: string,
  bucket: string,
): string | undefined => {
  if (typeof src !== "string") return;
  try {
    const url = new URL(src);
    if (url.origin !== new URL(supabaseUrl).origin) return;
    for (const mode of ["public", "sign", "authenticated"]) {
      const prefix = `/storage/v1/object/${mode}/${encodeURIComponent(bucket)}/`;
      if (url.pathname.startsWith(prefix)) {
        const path = decodeURIComponent(url.pathname.slice(prefix.length));
        if (path && !path.split("/").includes("..")) return path;
      }
    }
  } catch {
    // External URLs and inline images are not managed Storage files.
  }
};
